import React, { useState } from 'react'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'


const Wrapper = styled.div`
  position: relative;
  align-self: ${p => p.fromSelf ? 'flex-end' : 'flex-start'};
  margin-bottom: 20px;
  padding: 10px;
  width: fit-content;
  min-width: 40px;
  max-width: 85%;
  border-radius: 10px;
  background-color: ${p => p.fromSelf ? p.theme.colors.success : '#eee'};
  color: ${p => p.fromSelf ? p.theme.colors.on.success : '#000'};
  font-size: 13px;
`



export default injectIntl(({ note, noteId, type, fromSelf = true, removeNote, origin }) => {
  // eslint-disable-next-line
  const [hovered, setHovered] = useState(false)

  /* return (
    <Wrapper fromSelf={fromSelf} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {note.split('\n').map(n => (
        <React.Fragment>
          {n}<br />
        </React.Fragment>
      ))}
      {fromSelf !== 0 && (
        <DeleteWrapper fromSelf={fromSelf} hovered={hovered} onClick={() => removeNote({ noteType: type, noteId })}>
          <DeleteIcon className="far fa-trash" />
        </DeleteWrapper>
      )}
    </Wrapper>
  ) */

  // For deleting
  return (
    <Wrapper fromSelf={origin === 'portal' ? true : false} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {note.split('\n').map(n => (
        <React.Fragment>
          {n}<br />
        </React.Fragment>
      ))}
    </Wrapper>
  )
})